import m from 'mithril'

import { getAppState } from 'core/services/app-state'

import { removeParam } from 'core/helpers/url-helpers'
// import { getScenesById } from 'panorama/helpers'

import Pano from 'panorama/components/Pano'
import Overlay from 'info/components/Overlay'
import LogBook from 'info/components/LogBook'

// import sceneData from 'panorama/data/scenes'
// import overlayData from 'info/data/overlays'
// import transitionData from 'panorama/data/transitions'

/*
The Layout will act as the main traffic controller.
It will parse the URL, then get, check and pass the
data down to the other components.
*/

class Layout {
  constructor(vnode) {
    // this.updateStateFromURL = this._updateStateFromURL.bind(this)
    this.toggleLogBook = this._toggleLogBook.bind(this)
  }

  oninit(vnode) {
    let state = this
    state.logBookPage = 0
  }

  _toggleLogBook(page) {
    let state = this
    state.logBookPage = page

    m.redraw()
  }

  view(vnode) {
    let state = this

    const app = getAppState()

    return (
      <div className="layout">
        <Pano
          {...vnode.attrs}
          appState={app}
          logBookPage={state.logBookPage}
          toggleLogBook={state.toggleLogBook}
        />
        {vnode.attrs.overlay && typeof state.logBookPage !== 'number' && (
          <Overlay overlay={vnode.attrs.overlay} viewedScenes={app.viewedScenes} toggleLogBook={state.toggleLogBook} />
        )}
        <LogBook
          appState={app}
          pageIndex={state.logBookPage}
          toggleLogBook={state.toggleLogBook}
          currentScene={vnode.attrs.scene.id}
        />

        {vnode.children}
      </div>
    )
  }
}

export default Layout
